import vetting_modal from './vetting_modal.js'
import pages from './pages.js'
import firebase from './firebase.js'

export default {
  app_name: 'Bullrun',
  operation_name: 'Bullrun',
  display_app_name: 'Bullrun',
  stylesheet: '/bullrun.css',
  favicon: '/bullrun_favicon.png',
  base_api_url: 'https://bullrun.api.seasideapis.com/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'rebase',
  hr_email: 'hr@bullrun.co.il',
  operation_email: 'hr@bullrun.co.il',
  preview_link: 'https://web.bullrun.co.il/offer_preview/',
  company_panel_url: 'https://companies.bullrun.co.il/',
  seo_single_position_path: 'single_position',
  owners: [
    {
      name: 'מעין',
      phone_number: '053-442-8900',
      color: '#05cc47'
    },
    {
      name: 'נעם',
      phone_number: '053-476-6228',
      color: '#fdca30'
    },
    {
      name: 'הראל',
      phone_number: '050-639-9920',
      color: '#6d6e70'
    },
    {
      name: 'מערכת',
      phone_number: '050-639-9920',
      color: '#49c0b6'
    },
    {
      name: 'יובל',
      phone_number: '051-264-0834',
      color: '#fdca30'
    }
  ],
  field: 'ההנדסה האזרחית',
  recruitement_field: 'השמת מהנדסים אזרחיים',
  discrete_emoji: '😎',
  icon: '⚡',
  files: {
    is_profile_default_checked: false
  },
  applicant_modal: {
    languages: ['עברית', 'אנגלית']
  },
  applicant_history_company_modal: {
    job_title_options: ['מנהל פרויקט', 'מתכנת']
  },
  vetting_modal,
  pages,
  images: {
    logo_bright: '/bullrun_logo_bright.png',
    logo_dark: '/bullrun_logo_dark.png'
  },
  links: {
    website_url: 'https://www.bullrun.co.il/',
    web_base_url: 'https://web.bullrun.co.il/',
    app_store_url: 'https://apps.apple.com/il/app/rebase/id1473154558',
    google_play_url: 'https://play.google.com/store/apps/details?id=il.co.rebase'
  },
  hashtags: 'bullrun',
  firebase,
  full_env_name: 'bullrun_production',
  background_theme: '/bullrun_background_theme.jpg'
}
